export { default as Gallery } from "./pages/gallery/index.jsx";
export { default as Sliders } from "./pages/slider/index.jsx";
